<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-users title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.users' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.profile' : 'misc.edition.profile') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!isProfileLoading && profileForm">
        <form [formGroup]="profileForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="name" id="name" pInputText type="text">
              </div>
              <app-validation-errors [control]="profileForm.get('name')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="description" id="description" pInputText type="text">
              </div>
              <app-validation-errors [control]="profileForm.get('description')"></app-validation-errors>
            </div>
          </div>
          <div *ngIf="loadedData" class="col-12 md:col-12">
            <p-pickList [source]="availablePermissions" sourceHeader="{{ 'attribute.availablePermissions' | transloco }}:"
                        [target]="targetPermissions" targetHeader="{{ 'attribute.selectedPermissions' | transloco }}:"
                        [responsive]="true" filterBy="name" dragdrop="true"
                        sourceFilterPlaceholder="{{ 'filter.name' | transloco }}"
                        targetFilterPlaceholder="{{ 'filter.name' | transloco }}"
                        [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}"
                        [showSourceControls]="false" [showTargetControls]="false">
              <ng-template let-permission pTemplate="item">
                <div class="pick-list-item">
                  <div class="pick-list-detail">
                    <div class="mb-2 title-item-pick-list">{{permission.name}}</div>
                    <span>{{permission.description}}</span>
                  </div>
                </div>
              </ng-template>
            </p-pickList>
          </div>
        </form>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <p-button
                  [label]="'common.cancel' | transloco"
                  (onClick)="cancel()"
                  styleClass="p-button-danger"
                  iconPos="right"
                ></p-button>
                <p-button
                  [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                  [disabled]="!profileForm?.valid"
                  [loading]="persistingChanges"
                  (onClick)="persistProfileData()"
                  styleClass="p-button-primary"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isProfileLoading || profileForm == null">
        <div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 flex mt-4">
            <div style="width: 46%;">
              <div class="form-field mb-2">
                <label>{{ 'attribute.availablePermissions' | transloco }}:</label>
              </div>
              <p-skeleton width="100%" height="25rem"></p-skeleton>
            </div>
            <div style="width: 8%;">
              <div class="w-4rem m-8 ml-auto mr-auto">
                <div class="mb-2">
                  <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
                </div>
                <div class="mb-2">
                  <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
                </div>
                <div class="mb-2">
                  <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
                </div>
                <div class="mb-2">
                  <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
            <div style="width: 46%;">
              <div class="form-field mb-2">
                <label>{{ 'attribute.selectedPermissions' | transloco }}:</label>
              </div>
              <p-skeleton width="100%" height="25rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
